import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const ButtonContainer = styled.div `
  margin-top: var(--space-400);

  ${mediaQueries.tablet} {
    margin-top: var(--space-1000);
  }
`;
